import { createFileRoute, redirect } from '@tanstack/react-router';
import { TwitchApiClient } from '../../../services/Twitch';

export const Route = createFileRoute('/auth/twitch/callback')({
  component: () => <div></div>,
  loader: async ({ location }) => {
    const params = new URLSearchParams(location.hash);

    const accessToken = params.get('access_token');
    const token_type = params.get('token_type');
    const state = params.get('state') ?? '';

    if (!accessToken || !token_type) {
      return redirect({ to: '/auth/$provider/error', params: { provider: 'twitch' } });
    }

    const serverUrl = TwitchApiClient.getServerUrlFromState(state);

    if (!serverUrl) {
      return redirect({ to: '/auth/$provider/error', params: { provider: 'twitch' } });
    }

    try {
      const userInfo = await TwitchApiClient.getUserInfo({ accessToken, tokenType: token_type });
      await TwitchApiClient.passTwitchCallbackParams({
        accessToken,
        tokenType: token_type,
        providerId: userInfo.id,
        serverUrl,
      });
    } catch {
      return redirect({ to: '/auth/$provider/error', params: { provider: 'twitch' } });
    }

    return redirect({ to: '/auth/$provider/success', params: { provider: 'twitch' }, replace: true });
  },
});
